import Immutable from 'immutable';

import * as types from '../actions/actionTypes';

export const initialState = Immutable.Map({
  students: Immutable.List(),
  student: Immutable.Map(),
  loading: false,
  loadingMore: false,
  currentPage: 0,
  totalPages: 0,
  filters: Immutable.Map({
    name: '',
    cycle: '',
    gradeInstance: ''
  })
});

const studentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STUDENTS: {
      const newState = state.set('filters', Immutable.Map(action.filters));
      if (action.page === 1) {
        return newState.set('loading', true);
      }
      return newState.set('loadingMore', true);
    }
    case types.GET_STUDENTS_SUCCESS: {
      const { totalPages, page, students } = action;
      let newState = state;
      newState = newState.set('loading', false);
      newState = newState.set('loadingMore', false);
      newState = newState.set('currentPage', page);
      newState = newState.set('totalPages', totalPages);

      const currentStudents = page === 1 ? Immutable.List() : newState.get('students');
      const newStudents = currentStudents.concat(students);
      newState = newState.set('students', newStudents);

      return newState;
    }
    case types.GET_STUDENTS_ERROR: {
      let newState = state.set('loading', false);
      newState = newState.set('loadingMore', false);
      return newState;
    }
    case types.FETCH_STUDENT: {
      return state.set('loading', true);
    }
    case types.GET_STUDENT_SUCCESS: {
      const { student } = action;
      let newState = state.set('loading', false);
      newState = newState.set('student', Immutable.fromJS(student));
      return newState;
    }
    case types.GET_STUDENT_ERROR: {
      return state.set('loading', false);
    }
    default: {
      return state;
    }
  }
};

export default studentReducer;



// WEBPACK FOOTER //
// ./src/reducers/studentReducer.js